export enum ConfirmationModalMessages {
  ModalTestId = 'confirmation-modal',
  ArialLabelledBy = 'contained-modal-title-vcenter',
}
